export const AUTH_PARAMS = {
  AUTH_TOKEN: 'token',
  LOGIN_CODE: 'code',
  ENCOMPASS_LOAN_ID: 'loan_id_for_encompass',
  REDIRECT_URL: 'redirectUrl',
  ORIGIN: 'rg_origin',
}

/**
 * Check if the URL contains any authentication parameters
 * @param {string} [searchParams=window.location.search] - URL search parameters
 * @returns {boolean} True if any auth parameters are present
 */
export const hasAuthParams = (searchParams = window.location.search) => {
  const urlParams = new URLSearchParams(searchParams)
  const authToken = urlParams.get(AUTH_PARAMS.AUTH_TOKEN)
  const authCode = urlParams.get(AUTH_PARAMS.LOGIN_CODE)
  return authToken !== null || authCode !== null
}
